import type { IClaimsContent } from '../../types';
import * as m from '@/paraglide/messages.js';

export const getClaimsContent = (): IClaimsContent => ({
  medicalClaimForm: {
    href: '/inglelewer_international_student_medical_claim_form_final.pdf',
    title: m.ingle_claims_medical_title(),
    description: m.ingle_claims_medical_description(),
  },
  nonMedicalClaimForm: {
    href: '/inglelewer_third_party_claim_form.pdf',
    title: m.ingle_claims_non_medical_title(),
    description: m.ingle_claims_non_medical_description(),
  },
  authorizationText: m.ingle_claims_authorization_text(),
});
